// 尺寸454*320
import React from 'react'
import ReprintPage from '@/pages/AndroidDevice/reprint/print'
const ReprintHoneywellPage = () => {
  return <ReprintPage reprintType="Honeywell"></ReprintPage>
}
export default ReprintHoneywellPage
